// eslint-disable-next-line import/prefer-default-export
export const LOCATIONS_ALL_ID = 'all';
